import React from 'react';
import {arrayOf, shape, string, bool, func} from 'prop-types';
import BasicModal from 'components/common/BasicModal';

const ReportDownloadStatusModal = props => {
  const open = props.reportResponses.length > 0;
  let header = '';
  let viewing = {
    success: false,
    type: ''
  };

  if (open) {
    viewing = props.reportResponses[0];
    header = viewing.success ? 'Report Sent' : 'Error Downloading Report';
  }

  return (
    <BasicModal
      open={open}
      header={header}
      onClose={props.onClose}
      specialType={`small ${viewing.success ? 'success' : 'error'}-modal fadeInUp animResponse`}>
      <p>
        {viewing.success
          ? `A zip file will be emailed to you when the ${viewing.type} report has been created.`
          : `There was a problem creating the ${viewing.type} report. Please try again.`}
      </p>
    </BasicModal>
  );
};

ReportDownloadStatusModal.propTypes = {
  reportResponses: arrayOf(shape({
    type: string,
    success: bool
  })),
  onClose: func.isRequired
};

ReportDownloadStatusModal.defaultProps = {
  reportResponses: []
};

export default ReportDownloadStatusModal;



// WEBPACK FOOTER //
// ./public/components/modals/ReportDownloadStatusModal.jsx